import React from 'react'
import PropTypes from 'prop-types'
import { Tile, CaptionText } from '@paypalcorp/pp-react'
import cssModules from 'react-css-modules'
import styles from './charity_card.less'

class CharityCard extends React.Component {
  static propTypes = {
    charity: PropTypes.object,
  }
  render() {
    const { charity } = this.props
    return (
      <Tile card styleName="charity-wrap">
        <Tile.Content styleName="charity-title" data-nemo="charity-tile">
          <div
            styleName="charity-tile-logo"
            style={{
              background: `url(${
                charity.logo_url
              }) center center / contain no-repeat, center center`,
            }}
          />
          <div>
            <CaptionText styleName="charity-name">{charity.name}</CaptionText>
          </div>
        </Tile.Content>
      </Tile>
    )
  }
}
export default cssModules(CharityCard, styles)
